import defaultAreas from "~/common/constants/defaultAreas";
import { searchArea } from "./third-party";

export const getAreas = (locale) => {
    return defaultAreas.map((area) => ({
      ...area,
      name: searchArea({ alpha2: area.short.toLowerCase() }, locale)?.name,
    }));
  };
  